interface BlockingProgressProps {
  title: string;
  detail: string;
}

/** Blocks duplicate actions while a slow home-server operation is in flight. */
export function BlockingProgress({ title, detail }: BlockingProgressProps) {
  return (
    <div className="blocking-progress" role="status" aria-live="assertive" aria-atomic="true">
      <div className="blocking-progress-card">
        <div className="spinner" aria-hidden="true" />
        <strong>{title}</strong>
        <span>{detail}</span>
      </div>
    </div>
  );
}
